import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(() => ({
  wrapper: {
    display: 'flex',
    position: 'absolute',
    right: 0,
    paddingLeft: '1px',
    width: '124px',
    height: '38px',
    zIndex: 1,
  },
  nav: {
    width: '41px',
    height: '100%',
    cursor: 'pointer',
  },
}));
